module.exports = __webpack_public_path__ + "img/icon_1_15.314a9c7e.png";